<template>
    <div @click.self="removeWatermarks()" id="tm-sidebar-left" class="tm-sidebar-left scroller">
      <h4 id="sidebar-title" class="uk-heading-divider uk-margin-top">
            My Marks
      </h4>
      <div v-if="globalSessionInfo.isLoading.templates" class="uk-margin-top uk-text-center">
        <div class="uk-margin-bottom">Loading...</div>
        <span class="wm-green2"><div uk-spinner></div></span>
      </div>       
      <ul v-else class="uk-grid-small uk-child-width-1-1 uk-child-width-1-1@s uk-text-center uk-padding-none" uk-sortable="handle: .uk-card" uk-grid>
        <!-- ADD NEW MARK BUTTON -->   
        <li v-if="globalMarks.savedMarks.length === 0" class="uk-text-small uk-text-muted"><i>Create a new watermark.</i></li>     
        <!-- CREATE NEW MARK PLACEHOLDER -->
        <li v-if="globalMarks.savedMarks.length === 0" class="placeholder-container">
          <div class="uk-text-small uk-text-muted uk-text-left">
             Example Mark
          </div>          
          <div class="placeholder-card">
            <img src="/img/icons/logo-192.png">
            <div class="placeholder-overlay">  
              <p class="uk-padding-small">            
                <span class="uk-margin">Create your own:</span>
                <button @click="$router.push('/design');" class="placeholder-button">Click here</button>
              </p>
            </div>
          </div>
        </li> 
        <!-- WATERMARK COMPONENT -->
        <li v-else-if="globalSessionInfo.appliedWatermarkIndex === null || (typeof globalSessionInfo.appliedWatermarkIndex === 'undefined')" class="uk-text-small uk-text-muted uk-margin-small-bottom"><i>Choose a watermark:</i></li>     
        <li v-for="(mark, index) in globalMarks.savedMarks" :key="mark.id"> 
          <!-- using globalSessionInfo so this can be set by selectedId change or on import via a favorite without triggering the watcher and re-running -->
          <div v-bind:class="['uk-text-small', 'uk-text-muted', 'uk-text-left', {'selected-bold': (index === globalSessionInfo.appliedWatermarkIndex)}]">
             <i v-if="mark.favorite" class="material-icons" style="font-size: 12px; color: #f4c20d">star</i> 
             {{mark.name}}
          </div>
          <a id="card" @click.prevent="$parent.applyWatermark(index)">
            <!-- CARD -->
            <div v-bind:class="['uk-card', 'uk-box-shadow-hover-large', 'uk-card-default', 'uk-card-body', 'uk-padding-remove', 
                                {'uk-card-active': (index === globalSessionInfo.appliedWatermarkIndex),
                                'checkered-small-1': mark.isLightOrDark.isDark, 
                                'checkered-small-3': mark.isLightOrDark.isLight}]"> 
              <img :id="'mark_' + index" :src="mark.png">
              <!-- CONTROLS OVERLAY -->
              <div class="uk-panel uk-placeholder uk-position-bottom card-hover">
                <div class="uk-position-bottom uk-overlay uk-overlay-default template-hover-padding">                

                  <!-- Menu | Delete -->
                  <a @click.stop class="uk-icon-link uk-float-left uk-margin-remove" style="padding-right: 5px;"><i class="material-icons">expand_more</i></a>
                    <div uk-dropdown="pos: bottom-justify; boundary: !; boundary-align: true; mode: click" class="uk-padding-remove uk-margin-remove-top">
                      <p class="uk-margin-top">
                        <a @click.stop="removeElement(index)" class="uk-button uk-button-default uk-button-small" style="border-radius: 4px" href="#"><span uk-icon="trash" class="uk-margin-small-top uk-margin-small-bottom">Delete</span></a>
                      </p>
                    </div>
                  
                  <!-- Modal for Large View -->
                  <a @click.stop="fullscreen(index)" :href="'#modal-full-' + index" class="uk-icon-link" uk-toggle><i class="material-icons mirror">zoom_in</i></a>
                    <div :id="'modal-full-' + index"  class="uk-modal-container uk-text-center" uk-modal>
                      <div v-bind:class="['uk-modal-dialog', 'uk-margin-auto-vertical', {'dark-background': mark.isLightOrDark.isLight , 'light-background': mark.isLightOrDark.isDark}]">
                          <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
                          <h2 class="uk-modal-title uk-margin-remove uk-padding-small"><span class="uk-text">Name: </span>{{mark.name}}</h2>
                          <img :src="mark.png" class="uk-margin" style="height: auto; width: 50%; border: 2px solid gray">
                          <!-- <div v-html="mark.svg"></div> -->
                      </div>
                  </div>

                  <!-- Favorite -->
                  <a @click.stop="favorite(index)" class="uk-icon-link" uk-tooltip="title: Star your favorite mark!">
                    <i v-if="mark.favorite" class="material-icons" style="color: #f4c20d">star</i>
                    <i v-else class="material-icons">star_border</i>
                  </a>

                  <!-- Info Dropdown -->
                  <a @click.stop class="uk-icon-link uk-float-right uk-margin-remove" style="padding-right: 5px;"><i class="material-icons">info_outline</i></a>   
                    <div uk-dropdown="pos: bottom-justify; boundary: !; boundary-align: true; mode: click" class="uk-padding-remove uk-margin-remove">
                      <div class="uk-text-center uk-margin-small-top uk-text-small" style="min-height: 30px;">   
                        
                        <table class="uk-table uk-table-hover uk-table-divider uk-table-small uk-text-small">
                            <tbody>
                                <tr>
                                    <td>Type</td>
                                    <td>{{globalMarks.savedMarks[index].watermarkType.toUpperCase()}}</td>
                                </tr>
                                <tr>
                                    <td>Date</td>
                                    <td>{{globalMarks.savedMarks[index].createdOn}}</td>
                                </tr>
                            </tbody>
                        </table>

                      </div>
                    </div>                  

                </div>
              </div> 
            </div>
          </a>
        </li>                   
        <li>
          <a @click="$router.push('/design');" class="uk-margin-top" uk-icon="icon: plus; ratio: 2" uk-tooltip="title: Create New Watermark; pos: bottom"></a>   
        </li> 
      </ul>     
    </div>
</template>

<script>
    import FastAverageColor from 'fast-average-color/dist/index.es6';
    import Vue from 'vue'
    import firebase from 'firebase/app'

    require('jimp/browser/lib/jimp');
    const Jimp = window.Jimp;
    // import worker from 'workerize-loader!../../assets/js/composite-workers/jimpCompositeWorker.js'
    const base64_arraybuffer = require('base64-arraybuffer/lib/base64-arraybuffer.js');    

    // Define some helper functions
    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }

    export default {
        name: 'sidebar-templates',
        data() {
          return {       
          }
        },
        methods: {   
          favorite: function(index) {
            var me;
            me = this;             

            if (this.globalSessionInfo.currentUser.isLoggedIn === false) {
              UIkit.modal.alert('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">star</i> You must have an account to save Favorites! <hr> <span>Already have an account?</span> <router-link to="/login" class="uk-link">Log in.</router-link> <br> <span>Don\'t have an account? </span> <router-link to="/register" class="uk-link">Sign up.</router-link>')
              return
            }

            if (this.globalMarks.savedMarks[index].favorite) {
              // this is for a user unselecting a favorite
              // need to also set fave on savedMark for vue html for loop to be reactive
              this.globalMarks.savedMarks[index].favorite = false
              Vue.set(me.globalSessionInfo, 'favoriteIndex', null)
              Vue.set(me.globalSessionInfo, 'hasFavorite', false)
            } else {
              // user selects a new favorite... set all to false then set selected favorite
              for (let i = 0; i < this.globalMarks.savedMarks.length; i++) {
                  Vue.set(me.globalMarks.savedMarks[i], 'favorite', false)
              }
              Vue.set(me.globalSessionInfo, 'favoriteIndex', index)
              Vue.set(me.globalSessionInfo, 'hasFavorite', true)    
              this.globalMarks.savedMarks[index].favorite = true;                          

              this.$notify({
                group: 'loaded',
                title: 'Favorite Saved! <i class="material-icons uk-inline uk-margin-small-bottom" style="color: #f4c20d">star</i>',
                text: 'Everyone has a favorite!',
                type: 'info',
                duration: 50000                
              });              
            }
          },
          removeElement: function (index) {
            var me;
            me = this;

            UIkit.modal.confirm('<i class="material-icons uk-inline" style="color: #f4c20d; font-size: 48px;">warning</i> Permanently delete watermark: <b style="color: #f24c4e">' + me.globalMarks.savedMarks[index].name + '</b>?')
              .then(function () {         
                  // FIREBASE       
                  // If user logged in, delete from firebase and it will trigger refresh
                  if (me.globalSessionInfo.currentUser.isLoggedIn) {                
                    
                    // Delete from STORAGE
                    // Get a reference to the storage service, which is used to create references in your storage bucket
                    var storage = firebase.storage();
                    // Create a storage reference from our storage service
                    var storageRef = storage.ref(); 
                    var userPNGRef = storageRef.child('user/' + me.globalSessionInfo.currentUser.userId + '/watermarks/' + me.globalMarks.savedMarks[index].documentId + '.png')
                    var userSVGRef = storageRef.child('user/' + me.globalSessionInfo.currentUser.userId + '/watermarks/' + me.globalMarks.savedMarks[index].documentId + '.svg')
                    
                    // Delete the file
                    userPNGRef.delete().then(function() {
                    }).catch(function(error) {
                      // Uh-oh, an error occurred!
                    });

                    // Delete the file
                    userSVGRef.delete().then(function() {
                    }).catch(function(error) {
                      // Uh-oh, an error occurred!
                    });

                    // Delete from FIRESTORE
                    let deleteMarkRef = firebase.firestore().collection('watermarks').doc(me.globalSessionInfo.currentUser.userId).collection('marks').doc(me.globalMarks.savedMarks[index].documentId);            
                      deleteMarkRef.delete().then(function() {
                    }).catch(function(error) {
                        alert("Unable to remove watermark: ", error);
                    });
                  } else {
                    me.globalMarks.savedMarks.splice(index, 1);
                  }
                  
                  if (index === me.globalSessionInfo.appliedWatermarkIndex) {
                    me.removeWatermarks()
                  }
                  if (index === me.globalSessionInfo.favoriteIndex) {
                    // OMGSCOTT .. WTF ARE YOU DOING SETTING FAVORITES ON SAVEDMARKS ANDDDD IN GLOBALSESSIONINFO
                    Vue.set(me.globalSessionInfo, 'favoriteIndex', null)
                    Vue.set(me.globalSessionInfo, 'hasFavorite', false)
                    Vue.set(me.globalMarks.savedMarks[index], 'favorite', false)
                  }
              }, function () {}); 
          },
          removeWatermarks: function() {
            var me;
            me = this;
            // for some reason >= 0 is true for null values :| so i borke up to > 0 OR == 0
            if (me.globalSessionInfo.appliedWatermarkIndex > 0 || me.globalSessionInfo.appliedWatermarkIndex == 0) {
              UIkit.modal.confirm('<b>Remove watermark?</b><br>Removing watermark from <b>' + me.globalImages.uploadedImages.length + ' images</b>...')
                .then(function () {
                  for (let i = 0, len = me.globalImages.uploadedImages.length; i < len; i++) {
                    // remove dataURL
                    Vue.set(me.globalImages.uploadedImages[i], 'watermark', '') // dataURL
                    
                    // revoke and remove objectURL
                    URL.revokeObjectURL(me.globalImages.uploadedImages[i].dataURL);
                    Vue.set(me.globalImages.uploadedImages[i], 'dataURL', '') // objectURL 
                  }
                  // remove global "has wm" that is used for last minute checks and messaging
                  Vue.set(me.globalSessionInfo, 'appliedWatermark', false)
                  Vue.set(me.globalSessionInfo, 'appliedWatermarkIndex', null)                  
              }, function () {
              });  
            } else {
             // do nuffin
            }
          }         
        },
        mounted() {          
       }
    }
</script>


<style scoped>

  .tm-sidebar-left .uk-dropdown {
      border-radius: 4px;
      box-shadow: 0 10px 20px rgba(0,0,0,.4);
      min-width: 60px !important;
  }

  .uk-card {
      min-height: 100px;
      
      border-radius: 4px;
  }

  .uk-card-active {
      border: 2px solid #1fb58f;
      border-radius: 4px;
  }

  .uk-placeholder {
      border: none;
      padding: none !important;
  }

  .uk-panel .uk-padding-small {
      padding: 8px 10px 8px 10px;
  }

  .uk-overlay-default {
    border-radius: 0 0 4px 4px;
  }

  .card-color-picker{
      width: 100%;
      height: auto;
  }

  .checkered {
      background-color: #eee;
      background-image: linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02));
      background-size: 60px 60px;
      background-position: 0 0,30px 30px;
  }

  .checkered-small {
      background-color: #eee;
      background-image: linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02));
      background-size: 20px 20px;
      background-position: 0 0,10px 10px;
  }

  .checkered-small-1 {
    background-color: #eee;
    background-image: linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02)),linear-gradient(45deg,rgba(0,0,0,.02) 25%,transparent 0,transparent 75%,rgba(0,0,0,.02) 0,rgba(0,0,0,.02));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .checkered-small-2 {
    background-color: rgb(206, 206, 206);
    background-image: linear-gradient(45deg,rgba(1,1,1,.04) 25%,transparent 0,transparent 75%,rgba(1,1,1,.04) 0,rgba(1,1,1,.04)),linear-gradient(45deg,rgba(1,1,1,.04) 25%,transparent 0,transparent 75%,rgba(1,1,1,.04) 0,rgba(1,1,1,.04));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .checkered-small-3 {
    background-color: rgb(168, 168, 168);
    background-image: linear-gradient(45deg,rgba(1,1,1,.06) 25%,transparent 0,transparent 75%,rgba(1,1,1,.06) 0,rgba(1,1,1,.06)),linear-gradient(45deg,rgba(1,1,1,.06) 25%,transparent 0,transparent 75%,rgba(1,1,1,.06) 0,rgba(1,1,1,.06));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .checkered-small-4 {
    background-color: rgb(126, 126, 126);
    background-image: linear-gradient(45deg,rgba(1,1,1,.08) 25%,transparent 0,transparent 75%,rgba(1,1,1,.08) 0,rgba(1,1,1,.08)),linear-gradient(45deg,rgba(1,1,1,.08) 25%,transparent 0,transparent 75%,rgba(1,1,1,.08) 0,rgba(1,1,1,.08));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .checkered-small-5 {
    background-color: rgb(90, 90, 90);
    background-image: linear-gradient(45deg,rgba(1,1,1,.10) 25%,transparent 0,transparent 75%,rgba(1,1,1,.10) 0,rgba(1,1,1,.10)),linear-gradient(45deg,rgba(1,1,1,.10) 25%,transparent 0,transparent 75%,rgba(1,1,1,.10) 0,rgba(1,1,1,.10));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .checkered-small-6 {
    background-color: rgb(65, 65, 65);
    background-image: linear-gradient(45deg,rgba(1,1,1,.12) 25%,transparent 0,transparent 75%,rgba(1,1,1,.12) 0,rgba(1,1,1,.12)),linear-gradient(45deg,rgba(1,1,1,.12) 25%,transparent 0,transparent 75%,rgba(1,1,1,.12) 0,rgba(1,1,1,.12));
    background-size: 20px 20px;
    background-position: 0 0,10px 10px;
  }

  .selected-bold {
    font-weight: bold;
    color: rgb(68, 68, 68) !important;
  }

  .uk-modal-close-full {
    top: 10px;
    right: 10px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);    
    border-radius: 100px;
  }

  .template-hover-padding {
    padding: 4px 0 0 1px;
  }

  .uk-heading-divider {
      padding-bottom: 10px;
      border-bottom: 1px solid #e5e5e5;
  }

  .dark-background {
    background: rgb(20, 20, 20);
  }

  .light-background {
    background: rgb(240, 240, 240);
  }

  .uk-modal-container .uk-modal-dialog {
      max-width: 1200px !important;
  }

  .card-hover {
    display: none;
  }

  #card:hover .card-hover {
    display: block !important;
  }

  .mirror {
    -moz-transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -ms-transform: scale(-1, 1);
    transform: scale(-1, 1);
  }

  /* Example placeholder card */
  .placeholder-container {
    position: relative;
  }

  .placeholder-card {
    width: 100%;
    height: 100px;
    border: 2px solid #e5e5e5;
    box-shadow: inset 0 0 20px #e7e7e7;
    border-radius: 5px;
    position: relative
  }

  .placeholder-card img {
    width: 20px;
    height: 20px;
    position:absolute;
    bottom:10px;
    right:10px;    
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }

  .placeholder-container:hover .placeholder-overlay {
    opacity: 1;
  }

  .placeholder-overlay {
    width: 100%;
    height: 100%;
    transition: .5s ease;    
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    border-radius: 5px;
    background-image: radial-gradient(circle 248px at center, #11bb77 0%, #11bb77 47%, #1fb58f 100%);
    box-shadow: 10px;
  }

  .placeholder-overlay p {
    color: white;
  }

  .placeholder-button {
    border: none;
    padding: 6px 12px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 8px 2px;
    -webkit-transition-duration: 0.4s; /* Safari */
    transition-duration: 0.4s;
    cursor: pointer;  
    background: none;
    border: 2px solid white;
    color: white;
    border-radius: 50px;
  }

  .placeholder-button:focus {outline: none;}
  .placeholder-button:hover {background-color: #e7e7e75b;}
</style>